import { useQueryClient } from "@tanstack/react-query";
import { GraphQLClient } from "graphql-request";

import { Day, PendingPunch, Punch } from "../../generated-types";
import {
  GetDaysByUserQuery,
  GetDaysByUserQueryVariables,
  useGetDaysByUserQuery
} from "../../queries/days/index.generated";
import {
  useCreatePendingPunchMutation,
  useDeletePendingPunchMutation,
  useUpdatePendingPunchMutation
} from "./index.generated";

export const useCreatePendingPunch = ({
  day,
  setCurrentDay,
  client,
  variables
}: {
  day?: Day | null;
  setCurrentDay?: React.Dispatch<React.SetStateAction<Day | undefined | null>>;
  client: GraphQLClient;
  variables: GetDaysByUserQueryVariables;
}) => {
  const queryClient = useQueryClient();

  const { mutate: createPendingPunchMutation, ...options } =
    useCreatePendingPunchMutation(client, {
      onSuccess: (data) => {
        const daysData: GetDaysByUserQuery | null | undefined =
          queryClient.getQueryData(useGetDaysByUserQuery.getKey(variables));

        console.log("hook daysData ", daysData);

        const newPendingPunch = data?.createPendingPunch as PendingPunch;

        // Trova il punch ID dalla pending punch appena creata
        const punchId = newPendingPunch?.punch?.documentId;

        // Aggiorna i punches con la nuova pending punch
        const updatedPunches = (day as Day).punches?.map((punch) => {
          if (punch?.documentId === punchId) {
            const existingPendingPunches = punch?.pendingPunches || [];
            return {
              ...punch,
              pendingPunches: [...existingPendingPunches, newPendingPunch]
            } as Punch;
          }
          return punch;
        });

        // Gestisci il caso in cui pendings non esista
        const existingPendings = (day as Day).pendings || [];

        const newDay: Day = {
          ...(day as Day),
          punches: updatedPunches || [],
          pendings: [...existingPendings, newPendingPunch]
        };

        // se esiste
        if (setCurrentDay) {
          setCurrentDay(newDay);
        }

        const newData = daysData?.days?.map((_day) => {
          if (day?.documentId === _day?.documentId) {
            return newDay;
          }
          return _day;
        });

        const _data = {
          days: newData
        };

        if (daysData) {
          queryClient.setQueryData(
            useGetDaysByUserQuery.getKey(variables),
            (_old: any) => _data
          );
        }
      }
    });

  return { createPendingPunchMutation, options };
};

export const useDeletePendingPunch = ({
  day,
  setCurrentDay,
  client,
  variables
}: {
  day?: Day;
  setCurrentDay?: React.Dispatch<React.SetStateAction<Day | undefined | null>>;
  client: GraphQLClient;
  variables: GetDaysByUserQueryVariables;
}) => {
  const queryClient = useQueryClient();

  const { mutate: deletePendingPunchMutation, ...options } =
    useDeletePendingPunchMutation(client, {
      onSuccess: (data) => {
        const daysData: GetDaysByUserQuery | null | undefined =
          queryClient.getQueryData(useGetDaysByUserQuery.getKey(variables));

        // eliminare dalla cache
        const newPunches =
          day?.pendings?.filter(
            (punch) =>
              punch?.documentId !== data?.deletePendingPunch?.documentId
          ) ?? [];

        const newDay: Day = {
          ...(day as Day),
          pendings: newPunches
        };
        // se esiste
        if (setCurrentDay) {
          setCurrentDay(newDay);
        }

        const newData = daysData?.days?.map((_day) => {
          if (day?.documentId === _day?.documentId) {
            return newDay;
          }
          return _day;
        });

        const _data = {
          days: newData
        };

        if (daysData) {
          queryClient.setQueryData(
            useGetDaysByUserQuery.getKey(variables),
            (_old) => _data
          );
        }
      }
    });

  return { deletePendingPunchMutation, options };
};

export const useUpdatePendingPunch = ({
  day,
  setCurrentDay,
  client,
  variables
}: {
  day?: Day;
  setCurrentDay?: React.Dispatch<React.SetStateAction<Day | undefined | null>>;
  client: GraphQLClient;
  variables: GetDaysByUserQueryVariables;
}) => {
  const queryClient = useQueryClient();

  const { mutate: updatePendingPunchMutation, ...options } =
    useUpdatePendingPunchMutation(client, {
      onSuccess: (data) => {
        const daysData: GetDaysByUserQuery | null | undefined =
          queryClient.getQueryData(useGetDaysByUserQuery.getKey(variables));

        console.log("hook daysData", daysData);

        //  aggiorno la cache
        const newPunches =
          day?.pendings?.map((punch) => {
            if (
              punch?.documentId === data?.updatePendingPunch?.documentId
            ) {
              return data?.updatePendingPunch as PendingPunch;
            }
            return punch as PendingPunch;
          }) ?? [];

        const newDay: Day = {
          ...(day as Day),
          pendings: newPunches
        };

        // se esiste
        if (setCurrentDay) {
          console.log("newDay", newDay);
          setCurrentDay(newDay);
        }

        const newData = daysData?.days?.map((_day) => {
          if (day?.documentId === _day?.documentId) {
            return newDay;
          }
          return _day;
        });

        const _data = {
          days: newData
        };

        if (daysData) {
          queryClient.setQueryData(
            useGetDaysByUserQuery.getKey(variables),
            (_old) => _data
          );
        }
      }
    });

  return { updatePendingPunchMutation, options };
};
